import * as Yup from 'yup';
import { ValidationError } from 'yup';
export var buildPasswordRequirementsSchema = function buildPasswordRequirementsSchema(requirementValidators) {
  return Yup.string().test('password', 'password', function (value) {
    var errorMessages = '';
    requirementValidators.forEach(function (requirement) {
      if (!requirement.validationRegex.test(value !== null && value !== void 0 ? value : '')) {
        errorMessages += "|".concat(requirement.key);
      }
    });
    return errorMessages === '' ? true : new ValidationError(errorMessages, '', 'NewPassword', errorMessages);
  });
};